import buildConfig, { BaseAppConfig } from "./base";

const env = buildConfig();

export default {
  ...env,
  environment: "staging",
  baseApi: "https://api-dev.usewinslow.com/api",
  redirect: "https://staging.usewinslow.com/signup",
  clientUrl: "https://staging.usewinslow.com",
  wsCaptureUrl: "wss://api-dev.usewinslow.com/ws/assets/capture",
  wsRefreshUrl: "wss://api-dev.usewinslow.com/ws/shares/connect",
  wsPolicyStudioUrl: "wss://api-dev.usewinslow.com/ws/ps/policy-studio",
  wsAiUrl: "wss://api-dev.usewinslow.com/ws/ai/ask",
  wsAgentUrl: "wss://api-dev.usewinslow.com/ws/agent/ask",
  hostname: "staging.usewinslow.com",
  showStatuses: true,
  slackTestingMode: false,
  showReportCard: false,
  showWebsiteIngest: true,
  showPersonas: true,
  showUrlMultiInput: true,
  showPolicyStudio: true,
  killPolicyStudio: false,
  enforceHrisIntegration: false,
  showLinkRecordLogs: true,
  showDebugChat: false,
  enableWaz: true,
} as BaseAppConfig;
